import { NgIf } from '@angular/common';

import { afterNextRender, Component, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { PrimeNGModule } from '../../../primeng.module';
import { CookieConsentService } from '../../../services/cookie-consent/cookie-consent.service';
import { GoogleAnalyticsService } from '../../../services/google/google-analytics.service';
import { ToastService } from '../../../services/toast/toast.service';
import { WhatsAppService } from '../../../services/whats-app/whats-app.service';
import { Product } from '../../models/product/product';
import { SharedModule } from '../../shared.module';
import { WhatsAppComponent } from '../whats-app/whats-app.component';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [NgIf, WhatsAppComponent, PrimeNGModule, SharedModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnDestroy {
  @Input() justRights: boolean = false;

  public static readonly COOKIE_PRIVACY = 'cookie_accept_policy';
  public static readonly COOKIE_PRIVACY_FULL =
    'cookie_accept_policy=true; expires=Thu, 18 Dec 2099 12:00:00 UTC; path=/';

  public showWhatsApp = false;
  public hasConsent = false;

  public subscribeData = {
    email: '',
    name: '',
    phone: '',
  };

  public productWhatsApp?: Product | null;
  private subscriptionWhatsProduct?: Subscription;
  private subscriptionWhats?: Subscription;

  constructor(
    private whatsAppService: WhatsAppService,
    private consentService: CookieConsentService,
    private toastService: ToastService,
    private googleAnalyticsService: GoogleAnalyticsService
  ) {
    afterNextRender(() => {
      this.init();
    });
  }

  async init() {
    this.hasConsent = this.consentService.hasConsent();

    if (this.hasConsent) {
      this.googleAnalyticsService.applyConsent({
        ad_storage: 'granted',
        analytics_storage: 'granted',
      });
    }

    this.subscriptionWhatsProduct = this.whatsAppService
      .getOpenWhatsAppProduct()
      .subscribe(async (product: any) => {
        if (product) {
          this.productWhatsApp = product;
          this.showWhatsApp = true;
        } else {
          this.productWhatsApp = null;
        }
      });

    this.subscriptionWhats = this.whatsAppService
      .getOpenWhatsApp()
      .subscribe(async (show: boolean) => {
        this.showWhatsApp = show;
      });
  }

  onClickCookies(): void {
    this.consentService.giveConsent();
    this.hasConsent = true;

    this.googleAnalyticsService.applyConsent({
      ad_storage: 'granted',
      analytics_storage: 'granted',
    });

    window.location.reload();
  }

  onClickbtnCloseWhats(showMsg: boolean) {
    this.whatsAppService.setOpenWhatsAppProduct(null);
    this.showWhatsApp = false;

    if (showMsg) {
      this.toastService.success(
        'Mensagem enviada com sucesso! Aguarde que entraremos em contato.'
      );
    }
  }

  onClickbtnWhats() {
    this.whatsAppService.setOpenWhatsAppProduct(null);
    this.showWhatsApp = !this.showWhatsApp;
  }

  ngOnDestroy() {
    this.subscriptionWhatsProduct?.unsubscribe();
    this.subscriptionWhats?.unsubscribe();
  }
}
